import React from 'react';
import { Button } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';

const LoginButton: React.FC = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  if (isAuthenticated) {
    return null;
  }

  const handleLogin = () => {
    // If we're on the login page, redirect to dashboard after login
    // Otherwise, redirect back to the current page
    const returnTo = location.pathname === '/login' ? '/' : location.pathname;
    
    loginWithRedirect({
      appState: { returnTo }
    });
  };

  return (
    <Button
      type="primary"
      icon={<LoginOutlined />}
      loading={isLoading}
      onClick={handleLogin}
    >
      Log In
    </Button>
  );
};

export default LoginButton; 